/** How someone fell, as data: shared by the ragdoll that falls (`ragdoll.ts`) and the wire that tells others (`net/protocol.ts`). */

/**
 * How someone went down, enough to start the same fall again from the same
 * pose: thrown over a motorbike's bars or off its back, struck by a vehicle,
 * or fallen from a height. `v` is the velocity, scene x up z, m/s: the
 * bike's for a throw (with the way it faced), the hit's share for one struck
 * (with how high the bumper was), the body's for a fall.
 */
export const FALL_KINDS = ['bars', 'back', 'struck', 'fell'] as const;
export type FallKind = typeof FALL_KINDS[number];
export interface FallStart {
  kind: FallKind;
  v: [number, number, number];
  forward?: [number, number];
  bumper?: number;
}
